<template>
	<div class="loading" :style="cssProps">
		<div class="loader loader--style2" title="1">
			<div class="loader loader--style2" title="1">
				<svg
					version="1.1"
					id="loader-1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					:width="width + 'px'"
					:height="height + 'px'"
					viewBox="0 0 50 50"
					style="enable-background: new 0 0 50 50"
					xml:space="preserve">
					<path
						:fill="color"
						d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
						<animateTransform
							attributeType="xml"
							attributeName="transform"
							type="rotate"
							from="0 25 25"
							to="360 25 25"
							dur="0.6s"
							repeatCount="indefinite" />
					</path>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			width: {
				type: String,
				default: '50',
			},
			height: {
				type: String,
				default: '50',
			},
			color: {
				type: String,
				default: '#3C4B64',
			},
			align: {
				type: String,
				default: 'center',
			},
		},

		data() {
			return {
				float: 'unset',
				margin: 'auto',
			};
		},

		mounted() {
			if (this.align === 'left' || this.align === 'right') {
				this.float = this.align;
				this.margin = 'unset';
			} else {
				this.float = 'unset';
				this.margin = 'auto';
			}
		},

		computed: {
			cssProps() {
				return {
					'--width': this.width + 'px',
					'--height': this.height + 'px',
					'--float': this.float,
					'--margin': this.margin,
				};
			},
		},
	};
</script>

<style scoped>
	.loading {
		float: var(--float);
		margin: var(--margin);
		width: var(--width);
		height: var(--height);
	}
</style>
